<template>
  <div v-frag class="fadeIn">
    <CardIeaAppMain>
      <v-container fluid class="pa-4">
        <!-- HEADER -->
        <v-row align="center" class="mb-6">
          <v-col cols="12">
            <h1 class="text-h4 font-weight-bold bce-text-gradient">Plan de Estudio y Classroom</h1>
            <p class="grey--text text--darken-1">Accede a tus materiales de estudio, guías y códigos de acceso para las clases virtuales.</p>
          </v-col>
        </v-row>

        <div v-if="loading" class="text-center pa-10">
          <v-progress-circular indeterminate color="#E50050" size="48"></v-progress-circular>
          <div class="mt-4 grey--text">Cargando planes de estudio...</div>
        </div>

        <div v-else>
          <!-- DESKTOP VIEW -->
          <div v-if="$vuetify.breakpoint.mdAndUp">
            <div v-for="(planDeEstudio, planDeEstudioKey) in data" :key="planDeEstudioKey" class="mb-10">
              <div class="d-flex align-center mb-4">
                <v-icon color="#E50050" class="mr-2">mdi-folder-open-outline</v-icon>
                <h3 class="text-h5 font-weight-bold grey--text text--darken-3">{{ planDeEstudio.CursoNombre }}</h3>
              </div>

              <v-card class="rounded-xl overflow-hidden elevation-3">
                <v-simple-table class="bce-premium-table">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left font-weight-bold grey--text text--darken-2">Materia</th>
                        <th class="text-center font-weight-bold grey--text text--darken-2" style="width: 180px;">Código Classroom</th>
                        <th class="text-center font-weight-bold grey--text text--darken-2" style="width: 200px;">Materiales</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(planData, planDataKey) in planDeEstudio.planDeEstudio" :key="planDataKey" class="bce-tr-hover">
                        <td class="font-weight-medium py-4">{{ planData.catedra }}</td>
                        <td class="text-center">
                          <v-chip color="grey lighten-3" small label class="font-weight-black bce-code-chip">{{ planData.codClassRoom }}</v-chip>
                        </td>
                        <td class="text-center">
                          <v-btn 
                            v-if="planData.link != ''" 
                            @click="linkVideo(planData)" 
                            color="#E50050" 
                            dark 
                            depressed 
                            class="rounded-lg text-none px-4" 
                            small
                          >
                            Ir al Classroom
                          </v-btn>
                          <span v-else class="grey--text text-caption font-italic">No habilitado</span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </div>
          </div>

          <!-- MOBILE VIEW -->
          <div v-else>
            <div v-for="(planDeEstudio, planDeEstudioKey) in data" :key="planDeEstudioKey" class="mb-8">
              <h3 class="text-h6 font-weight-bold mb-3 bce-red-text">{{ planDeEstudio.CursoNombre }}</h3>
              <v-expansion-panels accordion class="rounded-xl elevation-2 overflow-hidden">
                <v-expansion-panel v-for="(planData, planDataKey) in planDeEstudio.planDeEstudio" :key="planDataKey">
                  <v-expansion-panel-header class="font-weight-bold py-4">
                    {{ planData.catedra }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="pb-2">
                    <v-divider class="mb-4"></v-divider>
                    <div class="d-flex justify-space-between align-center mb-3">
                      <span class="text-caption grey--text font-weight-bold">CÓDIGO CLASSROOM:</span>
                      <v-chip x-small class="font-weight-black">{{ planData.codClassRoom }}</v-chip>
                    </div>
                    <v-btn 
                      v-if="planData.link != ''" 
                      @click="linkVideo(planData)" 
                      block 
                      color="#E50050" 
                      dark 
                      depressed 
                      class="rounded-lg text-none font-weight-bold"
                    >
                      Acceder a Materiales
                    </v-btn>
                    <div v-else class="text-center py-2 grey--text text-caption">Contenido no disponible temporalmente</div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>

          <!-- EMPTY STATE -->
          <v-alert
            v-if="data.length === 0"
            border="left"
            colored-border
            color="grey darken-1"
            elevation="2"
            class="rounded-xl mt-4"
          >
            No se encontraron planes de estudio asociados a tu cuenta.
          </v-alert>
        </div>
      </v-container>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain.vue";

export default {
  name: "Classroom",
  components: { CardIeaAppMain },
  data: () => ({ 
    data: [], 
    loading: true 
  }),
  mounted() { 
    this.planDeEstudioGet(); 
  },
  methods: {
    async planDeEstudioGet() {
      this.loading = true;
      try {
        const res = await this.$API.get({ url: "plan-de-estudio/index", data: {} });
        this.data = res || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    linkVideo(data) {
       this.$store.dispatch("linkVideo", data.link);
       this.$router.push({ 
         name: 'MateriaCodigoClaseVideoAuth', 
         params: { catedra: data.IDCta, planestudio: data.codPlanEstudios_v2 }
       });
    }
  }
}
</script>

<style scoped>
.bce-text-gradient {
  background: linear-gradient(45deg, #1a237e 30%, #E50050 90%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bce-red-text {
  color: #E50050;
}

.bce-premium-table thead th {
  background-color: #f8f9fa !important;
  height: 50px !important;
  text-transform: uppercase;
  font-size: 11px !important;
  letter-spacing: 0.5px;
}

.bce-tr-hover:hover {
  background-color: #fffafa;
}

.bce-code-chip {
  letter-spacing: 1px;
}

.fadeIn { 
  animation: fadeIn 0.4s ease-in-out; 
}

@keyframes fadeIn { 
  from { opacity: 0; transform: translateY(10px); } 
  to { opacity: 1; transform: translateY(0); } 
}
</style>
